import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "./context/UserContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

const RootComponent = (
  <UserProvider>
    <App />
  </UserProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  process.env.NODE_ENV === "development" ? (
    <React.StrictMode>{RootComponent}</React.StrictMode>
  ) : (
    RootComponent
  )
);
